// eslint-disable-next-line no-undef
const chatTypeS = typeof chatType === 'undefined' ? 'aica' : chatType
// eslint-disable-next-line no-undef
const chatLanguageS = typeof chatLanguage === 'undefined' ? 'pl' : chatLanguage
const chatCredentials = {
  aica: {
    phone_number: '0048123456789'
  },
  mall: {
    phone_number: '0048111111111'
  },
  manual: {
    phone_number: '0048222222222'
  }
}
const translations = {
  pl: {
    title: 'Izbuś',
    subtitle: 'Obsługiwane przez',
    type_message: 'Zapytaj mnie o coś...',
    send: 'Wyślij',
    welcome: 'Cześć {name}, w czym mogę Ci pomóc?',
    limit_exceeded: 'Niestety nie mogę kontynuować, ponieważ limit odpowiedzi został wyczerpany.'
  },
  en: {
    title: 'Izbuś',
    subtitle: 'Powered by',
    type_message: 'Ask me something...',
    send: 'Send',
    welcome: 'Hi {name}, how can I help you?',
    limit_exceeded: 'Unfortunately, I cannot continue because the reply limit has been reached.'
  }
}
export default {
  type: chatTypeS,
  language: chatLanguageS,
  credentials: chatCredentials[chatTypeS],
  translations: translations[chatLanguageS]
}
